fragment AttachmentWithPriorityFragment on AttachmentWithPriority {

    ...AttachmentFragment

    pivot {
        priority
    }
}